'use client';
// -------------- IMPORTANT TODO --------------:
// When deleting a sample author and category documents must also be deleted if only that sample used them.
// Need tests for the new functionality
// Need many new tests for edit/upload internationalized samples
// some bug in delete sample, actually deletes but says that failed
// favorite tests fail
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import SamplesUploaderModel, { DEFAULT_CATEGORY_EN, DEFAULT_CATEGORY_RU } from './SamplesUploaderModel';
import samplesModel, { SAMPLES_MODE } from '../SamplesModel';
import './SamplesUploader.css';
import samplesUploaderModel from './SamplesUploaderModel';
import { Separator } from '@/components/ui/separator';
import {
  SingleFileInput,
  CommonFormInput,
  FormInputErrorMessage,
} from '@/components/ui/input';

// import CategorySelector from './category_selector';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { IconButton } from '@/components/ui/button';
import { FormItem, FormLabel } from '@/components/ui/form';
import { PiCheckLight } from 'react-icons/pi';
import toast from '@/components/ui/custom-toast';
import { useTranslation } from 'react-i18next';
import FormHeader from '@/components/ui/popover-header';
import { rightLanguage, getI18n } from '@/sharedTypes/helpers';
import type { Author, Category } from '@/sharedTypes/Api';
import { v4 } from 'uuid';

export type SampleFormValues = {
  name_en: string;
  name_ru: string;
  author_en: string;
  author_ru: string;
  category_en: string;
  category_ru: string;
  midi: File;
  xml: File;
};

const SamplesUploader = observer(() => {

  const form = useForm<SampleFormValues>({
    shouldUnregister: false,
    defaultValues: {
      name_en: SamplesUploaderModel.loadedTitle?.en || 'Sample title',
      name_ru: SamplesUploaderModel.loadedTitle?.ru || 'Пример заголовка',
      author_en: SamplesUploaderModel.loadedAuthor?.en || 'sample author',
      author_ru: SamplesUploaderModel.loadedAuthor?.ru || 'пример автора',
      category_en: SamplesUploaderModel.uploadCategory?.en || DEFAULT_CATEGORY_EN,
      category_ru: SamplesUploaderModel.uploadCategory?.ru || DEFAULT_CATEGORY_RU,
      // midi: SamplesUploaderModel.loadedMidi || undefined,
      // xml: SamplesUploaderModel.loadedMusicxml || undefined,
    },
  });
  const { control } = form;

  const { t } = useTranslation();

  const initialLang = getI18n()?.language || process.env.NEXT_PUBLIC_DEFAULT_LANG || 'ru';
  const [currentLang, setCurrentLang] = useState(initialLang);

  const onSubmit = async (values: SampleFormValues) => {
    // Validate all 6 fields
    const missingFields = [];
    if (!values.name_en) missingFields.push({ lang: 'en', field: 'name_en' });
    if (!values.name_ru) missingFields.push({ lang: 'ru', field: 'name_ru' });
    if (!values.author_en) missingFields.push({ lang: 'en', field: 'author_en' });
    if (!values.author_ru) missingFields.push({ lang: 'ru', field: 'author_ru' });
    if (!values.category_en) missingFields.push({ lang: 'en', field: 'category_en' });
    if (!values.category_ru) missingFields.push({ lang: 'ru', field: 'category_ru' });

    if (missingFields.length > 0) {
      console.log('[DEBUG] Missing fields:', missingFields);
      missingFields.forEach(({ field }) => {
        console.log(`[DEBUG] Setting error for field: ${field}`);
        form.setError(field as keyof SampleFormValues, { type: 'manual', message: t('form.required') });
      });
      const firstMissing = missingFields[0];
      if (firstMissing.lang !== currentLang) {
        console.log(`[DEBUG] Toggling currentLang from ${currentLang} to ${firstMissing.lang}`);
        setTimeout(() => {
          console.log(`[DEBUG] Actually toggling currentLang to ${firstMissing.lang}`);
          setCurrentLang(firstMissing.lang);
        }, 100);
      }
      toast({
        title: t('toast.error_title'),
        description: t('form.required'),
        type: 'error',
      });
      console.log('formState.errors:', form.formState.errors);
      return;
    }

    SamplesUploaderModel.loadedTitle = {
      en: values.name_en,
      ru: values.name_ru,
    };
    SamplesUploaderModel.loadedAuthor = {
      _id: SamplesUploaderModel.loadedAuthor?._id || v4(),
      en: values.author_en,
      ru: values.author_ru,
    };

    SamplesUploaderModel.uploadCategory = {
      _id: SamplesUploaderModel.uploadCategory?._id || v4(),
      en: values.category_en,
      ru: values.category_ru,
    };
    try {
      console.log('Uploading...', window);
      await SamplesUploaderModel.uploadLoadedMusicxml();
      // Обработка успешной загрузки произведения
      toast({
        title: t('toast.success_title'),
        description: t('toast.upload_success_desc'),
        type: 'success',
      });
    } catch (e) {
      console.log('Error submiting', e);
      // Обработка ошибки загрузки произведения
      toast({
        title: t('toast.error_title'),
        description: t('toast.upload_error_desc'),
        type: 'error',
      });
    }
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    // Prevent submission if MusicXML is invalid
    if (!samplesUploaderModel.musicxmlValid || samplesUploaderModel.musicxmlValidating) {
      e.preventDefault();
      toast({
        title: t('toast.error_title'),
        description: t('samples.uploader.invalid_musicxml'),
        type: 'error',
      });
      return;
    }
    form.handleSubmit(onSubmit)(e);
  };

  return (
    <FormProvider {...form}>
      <form
        onSubmit={handleFormSubmit}
        className='flex flex-col max-h-full overflow-hidden'
      >
        <FormHeader
          title={t('samples.new')}
          backButton={{
            onClick: () => {
              samplesModel.currentMode = SAMPLES_MODE.SELECT;
              samplesUploaderModel.reset();
            },
            testId: 'samples_uploader_back_btn',
          }}
          rightContent={
            <>
            <button
              className='cursor-pointer text-lg'
              onClick={() => setCurrentLang(currentLang === 'en' ? 'ru' : 'en')}
              type='button'
            >
              {currentLang === 'en' ? 'RU' : 'EN'}
            </button>
            <IconButton
              data-testid='samples_uploader_submit_btn'
              disabled={!samplesUploaderModel.musicxmlValid || samplesUploaderModel.musicxmlValidating}
              title={!samplesUploaderModel.musicxmlValid ? t('samples.uploader.invalid_musicxml') : undefined}
            >
              <PiCheckLight size={24} />
            </IconButton>
              </>
          }
        />
        <Separator />
        <div className='p-3 flex flex-col gap-3 overflow-auto flex-1 max-h-full'>
          {/* Category (folder) */}
          <FormItem className='grid grid-cols-[1fr_3fr] gap-3'>
            <FormLabel className='font-medium text-black text-sm text-end self-center'>
              {t('samples.folder')}
            </FormLabel>
            <div>
              {currentLang === 'en' ? (
                <>
                  <CommonFormInput
                    key='category_en'
                    name='category_en'
                    registerOptions={{ required: t('form.required') }}
                    placeholder={t('samples.folder')}
                  />
                  <FormInputErrorMessage key='category_en_error' name='category_en' />
                </>
              ) : (
                <>
                  <CommonFormInput
                    key='category_ru'
                    name='category_ru'
                    registerOptions={{ required: t('form.required') }}
                    placeholder={t('samples.folder')}
                  />
                  <FormInputErrorMessage key='category_ru_error' name='category_ru' />
                </>
              )}
            </div>
          </FormItem>
          {/* Author */}
          <FormItem className='grid grid-cols-[1fr_3fr] gap-3'>
            <FormLabel className='font-medium text-black text-sm text-end self-center'>
              {t('samples.author')}
            </FormLabel>
            <div>
              {currentLang === 'en' ? (
                <>
                  <CommonFormInput
                    key='author_en'
                    name='author_en'
                    registerOptions={{ required: t('form.required') }}
                    placeholder={t('samples.author')}
                    data-testid='samples_uploader_author_input'
                  />
                  <FormInputErrorMessage key='author_en_error' name='author_en' />
                </>
              ) : (
                <>
                  <CommonFormInput
                    key='author_ru'
                    name='author_ru'
                    registerOptions={{ required: t('form.required') }}
                    placeholder={t('samples.author')}
                    data-testid='samples_uploader_author_input'
                  />
                  <FormInputErrorMessage key='author_ru_error' name='author_ru' />
                </>
              )}
            </div>
          </FormItem>
          {/* Title */}
          <FormItem className='grid grid-cols-[1fr_3fr] gap-3'>
            <FormLabel className='font-medium text-black text-sm text-end self-center'>
              {t('samples.title')}
            </FormLabel>
            <div>
              {currentLang === 'en' ? (
                <>
                  <CommonFormInput
                    key='name_en'
                    name='name_en'
                    registerOptions={{ required: t('form.required') }}
                    placeholder={t('samples.title')}
                    data-testid='samples_uploader_name_input'
                  />
                  <FormInputErrorMessage key='name_en_error' name='name_en' />
                </>
              ) : (
                <>
                  <CommonFormInput
                    key='name_ru'
                    name='name_ru'
                    registerOptions={{ required: t('form.required') }}
                    placeholder={t('samples.title')}
                    data-testid='samples_uploader_name_input'
                  />
                  <FormInputErrorMessage key='name_ru_error' name='name_ru' />
                </>
              )}
            </div>
          </FormItem>
          <FormItem className='grid grid-cols-[1fr_3fr] gap-3'>
            <FormLabel className='font-medium text-black text-sm text-end self-center'>
              MusicXML
            </FormLabel>
            <div>
              <Controller
                control={control}
                name='xml'
                rules={{
                  required: `${t('form.upload_file_format_prompt')} .musicxml`,
                }}
                data-testid='samples_uploader_musicxml_controller'
                render={({ field: { onChange, value } }) => {
                  return (
                    <SingleFileInput
                      name='xml'
                      id='xml'
                      labelvalue={value?.name}
                      accept='.xml,.musicxml'
                      testid='samples_uploader_musicxml_input'
                      onChange={async (
                        e: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        console.log('samples_uploader_musicxml_input click');
                        const uploadedFile = e.target.files?.[0];
                        if (uploadedFile) {
                          try {
                            await SamplesUploaderModel.loadNewMusicxmlFile(
                              uploadedFile
                            );
                            onChange(uploadedFile);
                            // Обработка успешной загрузки файла
                            toast({
                              title: t('toast.success_title'),
                              description: t(
                                'toast.musicxml_upload_success_desc'
                              ),
                              type: 'success',
                            });
                          } catch (error) {
                            // Validation failed - clear the file input
                            onChange(undefined);
                            // Reset file input element
                            e.target.value = '';
                            // Error toast is already shown by loadNewMusicxmlFile
                            console.error(
                              'Error loading MusicXML file:',
                              error
                            );
                          }
                        }
                      }}
                    />
                  );
                }}
              />
            </div>
          </FormItem>
          <FormItem className='grid grid-cols-[1fr_3fr] gap-3'>
            <FormLabel className='font-medium text-black text-sm text-end self-center'>
              MIDI
            </FormLabel>
            <div>
              <Controller
                control={control}
                name='midi'
                render={({ field: { onChange, value } }) => {
                  return (
                    <SingleFileInput
                      name='midi'
                      id='midi'
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      //@ts-ignore
                      // value={value}
                      labelvalue={value?.name}
                      accept='.mid'
                      testid='samples_uploader_midi_input'
                      onChange={async (e) => {
                        const uploadedFile = e.target.files?.[0];
                        try {
                          await SamplesUploaderModel.loadNewMidiFile(
                            uploadedFile
                          );
                          onChange(uploadedFile);
                          // Обработка успешной загрузки файла
                          toast({
                            title: t('toast.success_title'),
                            description: t('toast.midi_upload_success_desc'),
                            type: 'success',
                          });
                        } catch (error) {
                          console.error('Error loading MIDI file:', error);
                          // Обработка ошибки загрузки файла
                          toast({
                            title: t('toast.error_title'),
                            description: t('toast.midi_upload_error_desc'),
                            type: 'error',
                          });
                        }
                      }}
                    />
                  );
                }}
              />
            </div>
          </FormItem>
        </div>
      </form>
    </FormProvider>
  );
});

export default SamplesUploader;
